// /expoTokens 검색 필드 정의 (SearchToolbar config).
// 기존 인라인 <TextField> 4개를 이 배열 하나로 대체한다.
// field 키 / operator 는 기존 코드와 100% 동일하게 유지한다.

import type { SearchFieldConfig } from "components/list";

export const expoTokensSearchFields: SearchFieldConfig[] = [
  { name: "id", label: "ID", type: "text", operator: "contains", width: 140 },
  { name: "token", label: "토큰", type: "text", operator: "contains", width: 200 },
  { name: "userId", label: "수신자ID", type: "text", operator: "contains", width: 200 },
  { name: "deviceId", label: "장치ID", type: "text", operator: "contains", width: 200 },
];
